import ActivityDetails from './ActivityDetails';

export default ActivityDetails;
